module.exports = __webpack_public_path__ + "img/strong.03928a57.png";